import React, { useState, useEffect, useRef } from 'react';
import { Formik } from 'formik';
const Filter = '/images/icons/Filter.svg';
import FilterOptionsInPrinciple from './FilterOptionsInPrinciple';
import * as _ from 'lodash';

const filterMenu = [
  {
    name: 'Product Type',
    type: 'check',
    dropdown: [
      {
        title: 'Home Loan'
      },
      {
        title: 'Personal Loan'
      },
      {
        title: 'Business Loan'
      },
      {
        title: '2 wheeler Loan'
      },
      {
        title: 'Loan against Property'
      }
    ]
  },
  {
    name: 'Status',
    type: 'check',
    dropdown: [
      {
        title: 'In Principle Pending'
      },
      {
        title: 'In Principle Released'
      },
      {
        title: 'In Principle Rejected'
      }
    ]
  }
];

const FilterInPrinciple = ({
  setFilteredData,
  addFilter,
  resetFilter,
  filterOptions = false,
  multiSelect = false,
  initialValues,
  filterContainerStyle,
  filterListsStyle,
  filerCaption = 'Filter',
  setFilterData,
  triggerNewFilterData,
  ...props
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const myref = useRef(null);

  const closeOnClickOutside = e => {
    if (myref.current && myref.current.contains(e.target)) {
      return;
    } else {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeOnClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', closeOnClickOutside, true);
    };
  }, []);

  let defaultInitialValues = {
    'Product Type': {
      'Home Loan': false,
      'Personal Loan': false,
      'Business Loan': false,
      '2 wheeler Loan': false,
      'Loan against Property': false
    },
    Status: {
      'In Principle Pending': false,
      'In Principle Released': false,
      'In Principle Rejected': false
    }
  };

  const initialValue = initialValues ? initialValues : defaultInitialValues;
  const doAssignData = (data, setFieldValue) => {
    let filterOptionList = filterOptions || filterMenu;
    if (!Array.isArray(filterOptionList)) return;

    filterOptionList?.map(el => {
      el?.dropdown?.map((dropEl, i) => {
        window['Obj2Arr_' + el?.name + '[' + i + ']'] = dropEl.title;
      });
    });

    filterOptionList?.map(({ name, type, dropdown }, i) => {
      let temp = Object.assign({}, data[name]);

      if (!multiSelect || name === 'Product') {
        temp = _.mapValues(temp, () => false);
      }
      dropdown?.map(async (each, index) => {
        if (each.checked) {
          temp[window['Obj2Arr_' + name + '[' + index + ']']] = true;
        }

        await setFieldValue(`${name}`, temp);
      });
    });
  };

  const doApplyFilters = async ({
    triggerNewFilterData,
    values,
    setFieldValue,
    applyHandler
  }) => {
    if (!triggerNewFilterData?.name || !triggerNewFilterData?.filterName)
      return;
    let temp = values[triggerNewFilterData?.name];

    temp[triggerNewFilterData?.filterName] = false;

    await setFieldValue(`${triggerNewFilterData?.name}`, temp);
    applyHandler();
  };

  return (
    <Formik initialValues={initialValue}>
      {propsFromFormik => {
        const {
          values: data,
          handleSubmit,
          setFieldValue,
          resetForm
        } = propsFromFormik;

        //updating data to formik state
        useEffect(() => {
          doAssignData(data, setFieldValue);
        }, [filterOptions, filterMenu]);

        //applying Filters
        const applyHandler = async () => {
          await handleSubmit();
          setShowOptions(false);
          addFilter(data);
          setFilterData(data);
        };

        //Reset Handler
        const resetHandler = () => {
          resetForm();
          resetFilter();
          setShowOptions(false);
        };
        useEffect(() => {
          if (showOptions) return;
          setFilterData(data);
        }, [data]);

        useEffect(() => {
          doApplyFilters({
            triggerNewFilterData: triggerNewFilterData,
            values: data,
            setFieldValue: setFieldValue,
            applyHandler: applyHandler
          });
        }, [triggerNewFilterData]);

        return (
          <form onSubmit={handleSubmit}>
            <div
              ref={myref}
              className=" bg-white font-roboto font-normal flex flex-col justify-start relative rounded cursor-pointer border border-grey-200"
              style={{
                paddingTop: '7px',
                paddingBottom: '7px',
                width: '138px',
                height: '38px'
              }}
              onClick={() => setShowOptions(!showOptions)}
            >
              <div className="flex flex-row justify-end  w-33 flex-row-reverse pl-3">
                <p className="text- text-sm ml-2">{filerCaption}</p>
                <img src={Filter} alt="Y" />
              </div>
              {showOptions && (
                <FilterOptionsInPrinciple
                  data={data}
                  setShowOptions={setShowOptions}
                  propsFromFormik={propsFromFormik}
                  filterMenu={filterOptions ? filterOptions : filterMenu}
                  setFilteredData={setFilteredData}
                  addFilter={data => addFilter(data)}
                  resetFilter={resetFilter}
                  multiSelect={multiSelect}
                  filterContainerStyle={filterContainerStyle}
                  filterListsStyle={filterListsStyle}
                  applyHandler={applyHandler}
                  resetHandler={resetHandler}
                />
              )}
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
export default React.memo(FilterInPrinciple);
